/**
 * this checks ownerships and confirms if userId is a primary owner
 * @param ownerships
 * @param userId
 * @returns {*}
 */
export default (ownerships, userId) => {
  return ownerships.some(ownership => ownership.isPrimary && ownership.userId === userId)
}
